/*=========================================================================================
  File Name: themeConfig.js
  Description: Theme configuration
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Vuesax from "vuesax";
import configuration from "../src/core/helpers/configuration";

// MAIN COLORS - VUESAX THEME COLORS
const colors = {
    primary: "#DA2D8A",
    success: "#28C76F",
    danger: "#EA5455",
    warning: "#FF9F43",
    dark: "#747474",
    darkblue: "#5E5873",
    blue: "#0D6EFD",
    hyperlead: "hyperlead",
    white: "#ffffff",
    twitter: "#00ACEE",
    darkgray: "#4b4b4b",
};

Vue.use(Vuesax, { theme: { colors } });

// CONFIGS
const themeConfig = {
    colors: colors,
    disableCustomizer: true, // options[Boolean] : true, false(default)
    disableThemeTour: false, // options[Boolean] : true, false(default)
    footerType: "static", // options[String]  : static(default) / sticky / hidden
    hideScrollToTop: false, // options[Boolean] : true, false(default)
    mainLayoutType: "vertical", // options[String]  : vertical(default) / horizontal
    navbarColor: "#fff", // options[String]  : HEX color / rgb / rgba / Valid HTML Color name - (default: #fff)
    navbarType: "floating", // options[String]  : floating(default) / static / sticky / hidden
    routerTransition: "zoom-fade", // options[String]  : zoom-fade / slide-fade / fade-bottom / fade / zoom-out / none(default)
    sidebarCollapsed: false, // options[Boolean] : true, false(default)
    theme: configuration.getTheme() ? configuration.getTheme() : "light", // options[String]  : "light"(default), "dark", "semi-dark"

    // Not required yet - WIP
    userInfoLocalStorageKey: "userInfo",

    // NOTE: themeTour will be disabled in screens < 1200. Please refer docs for more info.
};

export { colors };

export default themeConfig;



// WEBPACK FOOTER //
// ./src/themeConfig.js